import { ConfigurableText } from '@/app/components'
import { Icon } from '@/components'

interface PermissionHeaderProps {
  deviceName: string // example: "Tesla" or "Tesla Powerwall"
  missingPermissions: boolean
  missingRequiredPermissions: boolean
}

export function TeslaEnergyPermissionHeader({
  deviceName,
  missingPermissions,
  missingRequiredPermissions,
}: PermissionHeaderProps) {
  if (!missingPermissions) {
    return (
      <div className="flex flex-row items-start justify-start gap-2">
        <div className="flex flex-col gap-2">
          <ConfigurableText variant="h2">
            Great, we've got the right permissions!
          </ConfigurableText>
          <ConfigurableText variant="body4">
            The list below shows the permissions you've granted for your{' '}
            {deviceName}(s).
          </ConfigurableText>
        </div>
      </div>
    )
  }

  if (missingPermissions && !missingRequiredPermissions) {
    return (
      <div className="flex flex-row items-start justify-start gap-3">
        <div className="w-5 h-5 mt-1">
          <Icon name="AlertTriangleFilled" className="mr-2 text-yellow-500" />
        </div>
        <div className="flex flex-col gap-2">
          <ConfigurableText variant="h2">
            Are you sure you want to move forward without full permissions?
          </ConfigurableText>
          <ConfigurableText variant="body4">
            In order to make the most use of Optiwatt, we need you to update
            some permissions below, see the settings that have “Required”.
          </ConfigurableText>
        </div>
      </div>
    )
  }

  return (
    <div className="flex flex-row items-start justify-start gap-2">
      <div className="w-5 h-5 mt-1">
        <Icon name="AlertCircleFilled" className="text-red-500 " />
      </div>
      <div className="flex flex-col gap-2">
        <ConfigurableText variant="h2">
          Uh oh, we need you to update your permissions
        </ConfigurableText>
        <ConfigurableText variant="body4">
          In order to make the most use of Optiwatt, we need you to update some
          permissions below, see the settings that have "Required".
        </ConfigurableText>
      </div>
    </div>
  )
}
